import { Injectable } from '@angular/core';

import { YearsAtAlphaServiceMock } from '@app/core/services/years-at-alpha/years-at-alpha.service.mock';

@Injectable()
export class YearsAtAlphaService extends YearsAtAlphaServiceMock {}
